<template>
  <div>
    <b-col
      cols="12"
      :class="`border-style pad-5 ${parseInt(person_key) > 0 ? `mt-1` : ``}`"
    >
      <b-row :class="`${parseInt(person_key) !== 0 ? `pb-4` : ``}   m-auto`">
        <b-col cols="12" sm="6" md="4" class="pad-5">
          <b-form-group
            :label="$lang.gender"
            label-for="gender_id"
            :label-cols="$config.form.labelCol"
          >
            <selectFind
              :options="gender_options"
              v-model="person.gender_selected.$model"
              label="text"
              :placeholder="` `"
              class="multiselect-form"
              :isValid="
                person.gender_selected.$dirty
                  ? !person.gender_selected.$error
                  : null
              "
              :loading="genderLoading"
            />

            <b-form-invalid-feedback
              :style="{
                display: person.gender_selected.$error ? 'block' : 'none',
              }"
              id="gender_id-feedback"
            >
              {{
                $lang.error_required | replace($lang.gender)
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>

        <b-col cols="12" sm="6" md="4" class="pad-5">
          <b-form-group :label="$lang.name" :label-cols="$config.form.labelCol">
            <b-form-input
              type="text"
              :autocomplete="$lang.name"
              v-model="person.name.$model"
              :state="person.name.$dirty ? !person.name.$error : null"
            >
            </b-form-input>

            <b-form-invalid-feedback
              v-if="!person.name.required"
              id="name-feedback"
            >
              {{ $lang.error_required | replace($lang.name) }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback
              v-if="person.name.required && !person.name.maxLengh"
              id="name-feedback"
            >
              {{
                $lang.error_max | replace($lang.name, "بین 2 تا 35")
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>

        <b-col cols="12" sm="6" md="4" class="pad-5">
          <b-form-group
            :label="$lang.family"
            label-for="family"
            :label-cols="$config.form.labelCol"
          >
            <b-form-input
              v-model="person.family.$model"
              :state="person.family.$dirty ? !person.family.$error : null"
              type="text"
              :autocomplete="$lang.family"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!person.family.required"
              id="family-feedback"
            >
              {{
                $lang.error_required | replace($lang.family)
              }}</b-form-invalid-feedback
            >
            <b-form-invalid-feedback
              v-if="person.family.required && !person.family.maxLengh"
              id="family-feedback"
            >
              {{
                $lang.error_max | replace($lang.family, "بین 3 تا 35")
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>

        <b-col cols="12" sm="6" md="4" class="pad-5">
          <b-form-group
            :label="$lang.mobile"
            label-for="mobile"
            :label-cols="12"
          >
            <b-form-input
              type="text"
              :autocomplete="$lang.mobile"
              placeholder="مثال:09121112233 "
              :state="person.mobile.$dirty ? !person.mobile.$error : null"
              v-model="person.mobile.$model"
            >
            </b-form-input>
            <b-form-invalid-feedback id="mobile-feedback"
              >{{ $lang.error_required | replace($lang.mobile) }}
            </b-form-invalid-feedback>
            <div
              class="invalid-feedback"
              v-if="!person.mobile.minLengh | !person.mobile.maxLengh"
            >
              {{ $lang.error_length | replace($lang.mobile, 11) }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="4" class="pad-5">
          <b-form-group
            :label="$lang.city_address_home"
            :label-cols="$config.form.labelCol"
          >
            <selectAsync
              :options="location_options"
              v-model="person.location_selected.$model"
              label="caption"
              :asyncFind="getLocation"
              :isValid="
                person.location_selected.$dirty
                  ? !person.location_selected.$error
                  : null
              "
              :loading="locationLoading"
              :placeholder="` `"
            />
            <b-form-invalid-feedback
              :style="{
                display: person.location_selected.$error ? 'block' : 'none',
              }"
            >
              {{
                $lang.error_required | replace($lang.city_address_home)
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>

        <b-col cols="12" sm="6" md="4" class="pad-5">
          <b-form-group
            :label="$lang.regional_municipality"
            label-for="regional_municipality"
            :label-cols="$config.form.labelCol"
          >
            <b-form-input
              type="text"
              :autocomplete="$lang.regional_municipality"
              v-model="person.regional_municipality.$model"
              :state="
                person.regional_municipality.$dirty
                  ? !person.regional_municipality.$error
                  : null
              "
            >
            </b-form-input>
            <b-form-invalid-feedback id="description-feedback"
              >{{ $lang.error_required | replace($lang.regional_municipality) }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback
              v-if="person.regional_municipality.$error"
              id="name-feedback"
            >
              {{
                $lang.error_Value
                  .replace("{0}", $lang.Personal_biography)
                  .replace("{1}", "1")
                  .replace("{2}", "25")
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>

        <b-col cols="12" class="pad-5">
          <b-form-group
            :label="person_description || $lang.description"
            label-for="description"
            :label-cols="12"
          >
            <b-form-textarea
              class="min-heghit"
              :state="
                person.description.$dirty ? !person.description.$error : null
              "
              v-model="person.description.$model"
              type="text"
              :autocomplete="person_description || $lang.description"
              :rows="$config.form.textareaRows"
            ></b-form-textarea>
            <b-form-invalid-feedback id="description-feedback"
              >{{
                $lang.error_required
                  | replace(person_description || $lang.description)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button
        class="btn-my-desgin"
        v-if="parseInt(person_key) > 0"
        variant="danger"
        @click="removePersonColumn"
      >
        {{ $lang.delete_person_row }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
export default {
  props: {
    person: {
      type: Object,
    },
    person_key: {
      type: [String, Number],
    },
    item_index: {
      type: [String, Number],
    },
    gender_options: {
      type: Array,
    },
    genderLoading: {
      type: Boolean,
      default: false,
    },
    person_description: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      location_options: [],
      locationLoading: false,
    };
  },
  inject: ["locationRepository"],
  methods: {
    async getLocation(query) {
      if (!query || query.length < 2) {
        this.location_options = [];
        return;
      }
      try {
        const response = await this.locationRepository.list(query);
        let locations = response.data.data;
        this.location_options = locations;
      } catch (error) {
        this.$generateError(error);
        this.location_options = [];
      }
    },
    async getMobile(item) {
      let mobile = item.$model.mobile;
      if (mobile.length == 11) {
        try {
          let url =
            this.$config.api_url +
            this.$config.resources.person_full_name.replace(
              "{0}",
              item.$model.mobile
            );
          const response = await this.$httpService.get(url);
          let data = response.data.data;
          item.name.$model = data.name;
          item.family.$model = data.family;
          item.gender_selected.$model = this.gender_options.find(
            (x) => x.value == data.gender_id
          );
        } catch (error) {
          this.$generateError(error);
        }
      }
    },
    removePersonColumn() {
      this.$emit(
        "removePersonColumn",
        this.person,
        this.item_index,
        this.person_key
      );
    },
  },
};
</script>

<style>
.min-heghit {
  min-height: 30px;
}
</style>
